import { z } from 'zod'

const MarkSchema = z.object({
  type: z.string(),
  attrs: z.record(z.any()).optional(),
})

const BaseNodeSchema = z.object({
  type: z.string(),
  attrs: z.record(z.any()).optional(),
})

const TextNodeSchema = BaseNodeSchema.extend({
  text: z.string(),
  marks: z.array(MarkSchema).optional(),
})

const ContentNodeSchema = BaseNodeSchema.extend({
  content: z
    .array(
      z.union([
        TextNodeSchema,
        BaseNodeSchema.extend({
          content: z.array(z.union([TextNodeSchema, BaseNodeSchema])).optional(),
        }),
      ]),
    )
    .optional(),
})

export const JSONContentSchema = ContentNodeSchema

export const TiptapSchema = z.object({
  type: z.literal('doc'),
  content: z.array(ContentNodeSchema),
})
